<div fxLayout="column" fxLayoutAlign="center center" class="note-container">
  <div>
    <mat-form-field>
      <input matInput [formControl]="chatTitle" />
    </mat-form-field>
  </div>

  <div class="button-block">
    <button
      type="button"
      class="submit-button"
      mat-raised-button
      color="accent"
      [mat-dialog-close]="chatTitle.value"
      [disabled]="!chatTitle?.value?.length"
    >
      {{ 'BUTTONS.SAVE' | translate }}
    </button>
  </div>
</div>
